import React from "react";
import photo from "../../../img/extra/photo.jpg";

class Page5 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 5) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">
                    Meet Rosie who created her own career
                  </h3>
                </li>
              </ul>
            </nav>
            <div className="container-fluid h-100 vertical-center ">
              <div className="row h-100 justify-content-center">
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div className="card mb-4 box-shadow" id="pageContent">
                    <div className="card-body d-flex flex-column text-dark">
                      <span id="moduleContentText_2">
                        <img
                          className="photo"
                          src={photo}
                          alt="Card image cap"
                          style={{ float: "right", padding: "0px 15px" }}
                        />
                        <i>
                          "Hey, I’m Rosie and I studied Biomedical Sciences with
                          a placement year at Lilly. I loved my placement and
                          was really hoping to secure a graduate role,
                          unfortunately this didn’t happen and it knocked my
                          confidence. I came into my final year feeling lost and
                          decided to meet with my faculty careers adviser.
                          <br />
                          <br />
                          After the meeting I realised I have lots of skills and
                          that I can use my experience at Lilly to really
                          reflect on what is important to me in a career. I also
                          decided to take action by updating my CV and LinkedIn
                          profile and made sure I went to as many careers events
                          as possible. At the events, I pushed myself to talk to
                          company representatives. Whilst this is daunting, the
                          more I put myself ‘out there’ the more my confidence
                          grew. I proactively approached the faculty of science
                          marketing manager and secured some casual work; this
                          was supposed to be unpaid to start with but led to
                          paid work.
                          <br />
                          <br />
                          The more I did the more I realised I was better suited
                          to a small company, relationships really matter to me.
                          I didn’t want to be lost in a crowd of other grads. On
                          reflection, I actually realised if I had got the job
                          at Lilly, it wouldn’t have been right for me. In
                          February, I went to a talk by Becky Sage the CEO at
                          Interactive Scientific. As I listened to her
                          presentation, I sat there thinking we share the same
                          values and crucially a passion for science. I
                          approached her after her presentation and she
                          suggested I send her my CV which I did. Within a day
                          or two she emailed and invited me to meet her and the
                          team in Bristol. I didn’t know what to expect, I went
                          with an open mind and spent half a day learning about
                          what they do. I was encouraged to formally apply for
                          an internship there which I secured."
                        </i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page5;
